export default [
  {
    path: "/escrowTransfers",
    component: () => import("./layout"),
    children: [
      {
        path: "/escrowTransfers",
        name: "escrowTransfers.index",
        component: () => import("./index"),
      },
      {
        path: ":payment_id",
        props: true,
        name: "escrowTransfers.show",
        component: () => import("./show"),
      },
    ],
  },
];
